import { Controller } from "@hotwired/stimulus"

// Kept as empty shell — real-time pipeline step updates are now handled server-side via Turbo Streams
export default class extends Controller {
  static targets = ["message"]

  connect() {}
  disconnect() {}
}
